module.exports = __webpack_public_path__ + "static/webservices-logo-3d76d442560d277f08c7d8fcf96f9ad8.svg";